
import UserList from "../components/userList";



export default function UserPage() {

  return (
    <div className="w-full max-w-screen-xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 pt-28 pb-8">
      <UserList />
    </div>
  );
}
